// App.jsx o src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate   // ⬅️ nuevo import
} from 'react-router-dom';
import { useRef, useEffect } from "react";

import WOW from 'wowjs';

import LandingPage        from './pages/LandingPage';
import PrivacyPolicyPage  from './pages/extra/PrivacyPolicyPage';
import BestAppsForPersonalTrainers from './pages/extra/BestAppsForPersonalTrainers';
import ApplicationForTrainers      from './pages/extra/ApplicationForTrainers';
import './pages/LandingPage.css';

import './App.css';

function App() {
  const wowRef = useRef(null);

  useEffect(() => {
    // crea la instancia solo una vez
    wowRef.current = new WOW.WOW({ live: false });
    wowRef.current.init();

    // opcional: la expones para usarla en cualquier parte
    window.wow = wowRef.current;
  }, []);
  
  return (
    <Router>
      <Routes>
        {/* rutas válidas */}
        <Route path="/"        element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route
          path="/mejores-apps-entrenadores-personales"
          element={<BestAppsForPersonalTrainers />}
        />
        <Route
          path="/aplicacion-para-entrenadores-personales"
          element={<ApplicationForTrainers />}
        />
        {/* ruta comodín: LO ÚLTIMO */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
